export class CustomerLoyaltyDto {
  brandName?: string;
  brandId?: number;
  loyaltyPointsEarned?: number;
  stampsEarned?: number;
}
